function WelcomeAllBizzMobile({width, height}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 291 104">
      <defs>
        <filter id="Ellipse_139" width="80" height="80" x="211" y="12.421" filterUnits="userSpaceOnUse">
          <feOffset dy="2"></feOffset>
          <feGaussianBlur result="blur" stdDeviation="4"></feGaussianBlur>
          <feFlood floodOpacity="0.122"></feFlood>
          <feComposite in2="blur" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <filter id="Ellipse_139-2" width="80" height="80" x="0" y="12.421" filterUnits="userSpaceOnUse">
          <feOffset dy="2"></feOffset>
          <feGaussianBlur result="blur-2" stdDeviation="4"></feGaussianBlur>
          <feFlood floodOpacity="0.122"></feFlood>
          <feComposite in2="blur-2" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <filter id="Ellipse_139-3" width="87.158" height="87.158" x="160" y="8.421" filterUnits="userSpaceOnUse">
          <feOffset dy="2"></feOffset>
          <feGaussianBlur result="blur-3" stdDeviation="4"></feGaussianBlur>
          <feFlood floodOpacity="0.122"></feFlood>
          <feComposite in2="blur-3" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <filter id="Ellipse_139-4" width="87.158" height="87.158" x="43" y="8.421" filterUnits="userSpaceOnUse">
          <feOffset dy="2"></feOffset>
          <feGaussianBlur result="blur-4" stdDeviation="4"></feGaussianBlur>
          <feFlood floodOpacity="0.122"></feFlood>
          <feComposite in2="blur-4" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <filter id="Ellipse_720" width="104" height="104" x="93" y="0" filterUnits="userSpaceOnUse">
          <feOffset dy="2"></feOffset>
          <feGaussianBlur result="blur-5" stdDeviation="4"></feGaussianBlur>
          <feFlood floodOpacity="0.122"></feFlood>
          <feComposite in2="blur-5" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
      </defs>
      <g data-name="Group 8206" transform="translate(-127 -376)">
        <g data-name="Group 8197" transform="translate(178 386)">
          <g data-name="Group 8602" transform="translate(172 12.421)">
            <g filter="url(#Ellipse_139)" transform="translate(-223 -22.42)">
              <circle
                cx="28"
                cy="28"
                r="28"
                fill="#fff"
                data-name="Ellipse 139"
                transform="translate(223 22.42)"></circle>
            </g>
            <text data-name="" fontFamily="JioMoney" fontSize="17" transform="translate(18.667 34.667)">
              <tspan x="0" y="0">
                
              </tspan>
            </text>
          </g>
          <g data-name="Group 8603" transform="translate(-39 12.421)">
            <g filter="url(#Ellipse_139-2)" transform="translate(-12 -22.42)">
              <circle
                cx="28"
                cy="28"
                r="28"
                fill="#fff"
                data-name="Ellipse 139"
                transform="translate(12 22.42)"></circle>
            </g>
            <text data-name="" fontFamily="JioMoney" fontSize="17" transform="translate(18.667 34.667)">
              <tspan x="0" y="0">
                
              </tspan>
            </text>
          </g>
          <g data-name="Group 8597" transform="translate(121 8.421)">
            <g filter="url(#Ellipse_139-3)" transform="translate(-172 -18.42)">
              <circle
                cx="31.579"
                cy="31.579"
                r="31.579"
                fill="#fff"
                data-name="Ellipse 139"
                transform="translate(172 18.42)"></circle>
            </g>
            <text data-name="" fontFamily="JioMoney" fontSize="20" transform="translate(21.053 40.053)">
              <tspan x="0" y="0">
                
              </tspan>
            </text>
          </g>
          <g data-name="Group 8598" transform="translate(4 8.421)">
            <g filter="url(#Ellipse_139-4)" transform="translate(-55 -18.42)">
              <circle
                cx="31.579"
                cy="31.579"
                r="31.579"
                fill="#fff"
                data-name="Ellipse 139"
                transform="translate(55 18.42)"></circle>
            </g>
            <text data-name="" fontFamily="JioMoney" fontSize="20" transform="translate(21.053 40.053)">
              <tspan x="0" y="0">
                
              </tspan>
            </text>
          </g>
          <g data-name="Group 8595" transform="translate(53.999)">
            <g filter="url(#Ellipse_720)" transform="translate(-105 -10)">
              <circle cx="40" cy="40" r="40" fill="#fff" data-name="Ellipse 720" transform="translate(105 10)"></circle>
            </g>
            <text data-name="" fontFamily="JioMoney" fontSize="32" transform="translate(24 54)">
              <tspan x="0" y="0">
                
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default WelcomeAllBizzMobile
